import { Contexte } from '@/domaine/Contexte'

export const AssimiléSalariéContexte: Contexte = {
	'entreprise . imposition': "'IS'",
	'entreprise . catégorie juridique': "'SAS'",
	'entreprise . associés': "'unique'",
}
